var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main--text mb-10",domProps:{"innerHTML":_vm._s(_vm.data.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }